export var flushBodiedSyncBlocks = function flushBodiedSyncBlocks(syncBlockStore) {
  return syncBlockStore.sourceManager.flush();
};